export default __webpack_public_path__ + "static/media/20_1_0.0b5ef0b4.png";